import { CouponBlueprint } from "../models/coupon-blueprint";

export class CouponHolder 
{
    constructor(name:string, detail:string, orderfloor:string, orderfloorvalue:number, valuestring:string, available:boolean, used:boolean, floorrejected:boolean, blueprint:CouponBlueprint)
    {
        this.Name = name;
        this.Detail = detail;
        this.ValueString = valuestring;
        this.FloorRejected = floorrejected;
        this.Available = available;
        this.Used = used;
        this.OrderFloor = orderfloor;
        this.OrderFloorValue = orderfloorvalue;

        this.Blueprint = blueprint;
    }

    public Name:string;
    public Detail:string;
    public OrderFloor:string;
    public OrderFloorValue:number;
    public ValueString:string;

    public Available:boolean;
    public Used:boolean;
    public FloorRejected:boolean;

    public Blueprint:CouponBlueprint;
}
